<script setup>
defineProps({
  title: { type: String, default: '' },
  steps: { type: Array, default: () => [] } // Array of [name, text]
})
</script>

<template>
  <section class="block">
    <div class="wrap">
      <div class="sec-h">
        <h2>{{ title }}</h2>
        <p>Three steps, a few seconds — no account needed.</p>
      </div>
      <div class="how">
        <div v-for="(step, i) in steps" :key="i" class="how-step">
          <div class="n">{{ i + 1 }}</div>
          <h4>{{ step[0] }}</h4>
          <p>{{ step[1] }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
